import { PlatformEdition } from 'src/types/platform-feature';
import type { PlatformFeature } from 'src/types/platform-feature';

/** Used while the backend does not send `platform.edition` yet. */
export const DEFAULT_PLATFORM_EDITION: PlatformEdition = PlatformEdition.CREATOR;

/**
 * Which features each edition has. This is the one place product decisions land:
 * hiding a feature for an edition is flipping one boolean here.
 *
 * Exhaustive both ways — a new edition or a new feature fails to compile until it is
 * decided for every row. The backend's `platform.feature_matrix` wins over this key by
 * key; once the backend serves the full matrix, this becomes a fallback and then goes.
 */
export const EDITION_FEATURE_MATRIX: Record<PlatformEdition, Record<PlatformFeature, boolean>> = {
  [PlatformEdition.CREATOR]: {
    sales_history: true,
    payment_methods: true,
    course_tariffs: true,
    public_pages: true,
    chatbot: true,
    corporate_learning: false,
  },
  [PlatformEdition.CORPORATE]: {
    sales_history: false,
    payment_methods: false,
    course_tariffs: false,
    public_pages: false,
    chatbot: false,
    corporate_learning: true,
  },
};
